//e.g. returns 2 for stat.name like "X_0% Damage for X_1 seconds"
export const getStatValueSize = function(stat) {
    if(stat && stat.name) {
        const statName = stat.name;
        return statName.includes("X_2") ? 3 : (statName.includes("X_1") ? 2 : (statName.includes("X_0") ? 1 : 0));
    }

    return 0;
}

//e.g. returns range strings like " [3 - 5]"
export const getStatRangeString= function(stat, index) {
    if(stat) {
        const rangePart1 = stat.floatMinValues && stat.floatMinValues.length > index ? stat.floatMinValues[index] : "";
        const statMaxValue = stat.floatMaxValues && stat.floatMaxValues.length > index ? stat.floatMaxValues[index] : "";
        const rangePart2 = rangePart1 && statMaxValue ? " - " + statMaxValue : statMaxValue;
        const statRange = rangePart1 || statMaxValue ? " [" + rangePart1 + rangePart2 + "]" : "";
        return statRange;
    }

    return "";
}

const supportedStatXs = ["X_0", "X_1", "X_2"]
export const getStatValue = function(stat, valueIndex) {
    return stat && stat.floatValues && stat.floatValues.length > valueIndex && stat.floatValues[valueIndex] ? stat.floatValues[valueIndex] : 0;
}

//e.g. replaces stat.name like "X_0% Damage for X_1 seconds" with "10% Damage for 5 seconds"
export const getStatNameWithIncludedValues= function(stat) {
    const statValueSize = getStatValueSize(stat);
    const loopLimit = Math.min(statValueSize, supportedStatXs.length);

    let result = stat.name;

    for (let i = 0; i <= loopLimit; i++) {
        let statValueX_i = getStatValue(stat, i);
        let statRange = getStatRangeString(stat, i);
        result = result.replace(supportedStatXs[i],statValueX_i) + statRange;
    }

    return result;
}

//only for aspectsOrUniques --> if isAspect===false, then we expect isUnique===true
const expandLabelsObjectsArray=function(divIndex, stat, isAspect, valueIndex, statValuesSize, targetString, labelsArray, textStyle, valueStyle, rangeStyle) {

    const statRange = getStatRangeString(stat, valueIndex)
    let statValue = getStatValue(stat, valueIndex);
    const splitValue = supportedStatXs[valueIndex];

    if(!targetString.includes(splitValue)) {
        labelsArray.push({labelKey: divIndex + "valueIndex " +valueIndex + " label 0", labelStyle: textStyle, labelValue: targetString});
        return labelsArray;
    }

    const parts = targetString.split(splitValue);

    labelsArray.push({labelKey: divIndex + "valueIndex " +valueIndex + " label 0", labelStyle: textStyle, labelValue: parts[0]});

    if(isAspect && stat.maxAspect)
    {
        statValue = statValue + " (MAX) ";
    }

    labelsArray.push({labelKey: divIndex + "valueIndex " +valueIndex + " label 1", labelStyle: valueStyle, labelValue: statValue});
    labelsArray.push({labelKey: divIndex + "valueIndex " +valueIndex + " label 2", labelStyle: rangeStyle, labelValue: statRange});

    if(parts.length > 2) {
        for (let i = 1; i < parts.length; i++) {
            labelsArray.push({labelKey: divIndex + "valueIndex " +valueIndex + " label " + i + " 1", labelStyle: textStyle, labelValue: parts[i]});

            if(i < parts.length -1) {
                labelsArray.push({labelKey: divIndex + "valueIndex " +valueIndex + " label " + i + " 2", labelStyle: valueStyle, labelValue: statValue});
            }
        }
        return labelsArray;
    }

    if(valueIndex+1 === statValuesSize) {
        labelsArray.push({labelKey: divIndex + "valueIndex " +valueIndex + " label 3", labelStyle: textStyle, labelValue: parts[1]});
        return labelsArray;
    } else {
        const newValueIndex = valueIndex + 1;
        return expandLabelsObjectsArray(divIndex, stat, isAspect, newValueIndex, statValuesSize, parts[1], labelsArray, textStyle, valueStyle, rangeStyle);
    }
}

export const getStatNameLabelObjects=function(divIndex, stat, isAspect, textStyle, valueStyle, rangeStyle) {
    const statValuesSize = getStatValueSize(stat);

    let result = []

    if(statValuesSize > 0) {
        result = expandLabelsObjectsArray(divIndex, stat, isAspect, 0, statValuesSize, stat.name, result, textStyle, valueStyle, rangeStyle)
    } else {
        result.push({labelKey: divIndex + "valueIndex 0 label 0", labelStyle: textStyle, labelValue: stat.name});
    }

    return result;
}